import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';
import type { UploaderProps } from './Uploader';
import Tag from 'components/Tag';

export interface InvoiceAnalyzerWrapperProps
  extends Pick<UploaderProps, 'type'> {
  children: ReactNode;
}

const InvoiceAnalyzerWrapper: FC<InvoiceAnalyzerWrapperProps> = ({
  type,
  children,
}) => {
  return (
    <div
      className={clsx('w-full', {
        'rounded-md border border-blue-700 bg-background-base-surface-2 p-6':
          type === 'order-service' || type === 'inventory',
      })}
    >
      {type === 'dashboard' && (
        <div className="mb-4 flex items-center gap-1 text-[28px] font-bold leading-9 text-content-base-default">
          <span>Broadband savings made easy—just upload your invoice.</span>
          <BetaFeatureTag />
        </div>
      )}

      {type === 'order-service' && (
        <div className="mb-6 flex flex-col items-center gap-1">
          <p className="text-[28px] font-bold leading-9 text-content-base-default">
            Upload an invoice.{' '}
            <span className="bg-[linear-gradient(90deg,_#7E77B3_62.59%,_#8989FF_71.66%,_#6C9DFF_81.07%,_#78CFDA_90.55%,_#9FF4A9_100%)] bg-clip-text text-transparent">
              Get an Access quote.
            </span>
          </p>
          <p className="text-xs font-semibold text-content-base-subdued">
            We’ll review your current services and show how Granite stacks
            up—fast, clear, and personalized.
          </p>
        </div>
      )}
      {type === 'inventory' && (
        <div className="mb-6 flex flex-col items-center gap-1">
          <p className="flex items-center gap-1 text-[28px] font-bold leading-9 text-content-base-default">
            All your services.{' '}
            <span className="bg-[linear-gradient(90deg,_#7E77B3_62.59%,_#8989FF_71.66%,_#6C9DFF_81.07%,_#78CFDA_90.55%,_#9FF4A9_100%)] bg-clip-text text-transparent">
              One bill.
            </span>
            <span className="inline-flex">
              <BetaFeatureTag />
            </span>
          </p>
          <p className="text-xs font-semibold text-content-base-subdued">
            Let Granite handle your existing services on one easy-to-manage
            invoice.
          </p>
        </div>
      )}
      {children}
    </div>
  );
};

const BetaFeatureTag: FC = () => (
  <span className="ml-2 inline-flex align-middle">
    <Tag
      content={{
        type: 'label',
        label: `BETA`,
      }}
      status="custom"
      className="!bg-status-info-default !text-content-flip-default"
    />
  </span>
);

export default InvoiceAnalyzerWrapper;
